import { useMutation, useQuery } from "react-query"
import customAxios from "../utils/customAxios"
import { toast } from "react-toastify"
import { AxiosError } from "axios"

const axios = customAxios()

const fetchItemApi = () => {
  return axios.get(`/camt/item`)
}

interface searchwordType {
  search: string
}

const fetchThemaApi = (searchWord: searchwordType) => {
  return axios.post(`/cmat/system/thema`, searchWord)
}

const fetchUploadApi = (formData: FormData) => {
  const config = { headers: { "Content-Type": "multipart/form-data" } }
  return axios.post(`/cmat/system/upload`, formData, config)
}

export const useItemApi = (prop?: any) => {
  return useQuery(["fetchItemApi", prop], fetchItemApi, {
    staleTime: 10000,
    select,
    onError,
    refetchOnWindowFocus: false,
  })
}

export const useThemaApi = (prop?: any) => {
  return useMutation(fetchThemaApi, {
    onSuccess: () => {
      toast.success("성공")
    },
    onError: (error: AxiosError) => {
      if (error.response?.status === 406) {
        toast.error(
          "임베딩 벡터가 없는 단어 입니다. 다른 자연어 모델을 사용하세요"
        )
      } else if (error.response?.status === 405) {
        toast.error("학문프로파일에 없는 단어입니다. 다른 단어를 입력해주세요.")
      } else {
        console.log(error)
        toast.error("서버 에러입니다.")
      }
    },
  })
}

export const useUploadApi = (prop?: any) => {
  return useMutation(fetchUploadApi, {
    onSuccess: () => {
      toast.success("업로드 성공!")
    },
    onError: (error: AxiosError) => {
      console.log(error)
      toast.error("서버 에러입니다.")
    },
  })
}
// api 응답 데이터 가공하는 부분
const select = (response: any) => {
  return response.data
}

const onError = (err: any) => {
  return err
}
